import { Component, OnInit } from "@angular/core";

// import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MatDialog } from "@angular/material/dialog";

import { AddSegmentDialogComponent } from "./add-segment-dialog/add-segment-dialog.component";
import { EditSegmentDialogComponent } from "./edit-segment-dialog/edit-segment-dialog.component";
import { AdduserlistComponent } from "./adduserlist/adduserlist.component";
import { NotificationsService } from "../../services/notifications.service";
import { MessageService } from "../../services/message.service";
import { ConfirmationDialogComponent } from "../confirm-dialog/confirm-dialog.component";

@Component({
	selector: "rm-manage-segment",
	templateUrl: "./manage-segment.component.html",
	styleUrls: ["./manage-segment.component.css"],
})
export class ManageSegmentComponent implements OnInit {
	columns: any[] = [
		{ name: "name", displayName: "Name" },
		{ name: "description", displayName: "Description" },
		{
			name: "createdon",
			displayName: "Created On",
			type: "date",
			format: "DD/MM/YYYY h:mma",
		},
		{ name: "usersCount", displayName: "Users" },
		{ name: "actions", type: "actions", displayName: "Actions" },
	];
	data: any[];
	segments: any[] = [];
	subscriptions: any[] = [];
	id: any;
	role: any;
	totalCount: number = 5;
	searchTxt: string = "";
	searchByText: boolean = false;

	constructor(
		private dialog: MatDialog,
		private msgService: MessageService,
		private notificationService: NotificationsService
	) {}

	ngOnInit() {
		this.getSegments();
	}

	getSegments() {
		this.notificationService.getSegmentsList().subscribe(
			(response: any) => {
				this.segments = response.data;
				this.segments.forEach((item) => {
					item["actions"] = [
						{
							name: "edit",
							tip: "Edit Segment",
						},
					];
					if (item.isAssociated === true) {
						if (item.isActive === true) {
							item["actions"].push({
								name: "not_interested",
								tip: "De-activate Segment",
							});
						} else {
							item["actions"].push({
								name: "check_circle",
								tip: "Activate Segment",
							});
						}
					} else {
						item["actions"].push({
							name: "delete",
							tip: "Delete Segment",
						});
					}

					item["actions"].push({
						name: "groups",
						tip: "Segment user list",
					});
				});
				// console.log('segments', this.segments);
			},
			(err) => {
				console.log("error", err);
			}
		);
	}

	onActionClicked(e) {
		var rec = e.record;
		console.log("rec", rec);
		console.log("onActionClicked: ", e);
		switch (e.actionName.name) {
			case "edit":
				this.showEditSegmentDialog(rec);
				break;
			case "groups":
				this.showSegmentUserListDialog(rec);
				break;
			case "delete":
				const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
					width: "450px",
					data: {
						message: "Are you sure you want to delete this segment?",
					},
				});
				dialogRef.afterClosed().subscribe((result) => {
					if (result === "yes") {
						this.notificationService.deleteSegment(rec.id).subscribe(
							(response: any[]) => {
								this.msgService.showSuccess(this.msgService.segmentDelete);
								this.getSegments();
							},
							(error) => {
								console.log("Service error:");
							}
						);
					} else {
					}
					this.getSegments();
				});
				break;
			case "not_interested":
				const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
					width: "450px",
					data: {
						message: "Are you sure you want to de-activate the segment?",
					},
				});
				dialogRef1.afterClosed().subscribe((result) => {
					if (result == "yes") {
						this.notificationService
							.deActivateSegment(rec.id, { isActive: false })
							.subscribe(() => {
								this.msgService.showSuccess(this.msgService.segmentDeactivate);
								this.getSegments();
							});
					}
				});
				break;
				break;
			case "check_circle":
				const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
					width: "450px",
					data: {
						message: "Are you sure you want to activate the segment?",
					},
				});

				dialogRef2.afterClosed().subscribe((result) => {
					if (result == "yes") {
						this.notificationService
							.deActivateSegment(rec.id, { isActive: true })
							.subscribe(() => {
								this.msgService.showSuccess(this.msgService.segmentActivate);
								this.getSegments();
							});
					}
				});
			default:
				console.log("Unhandled actionable: ", e.actionName);
		}
	}

	addSegment() {
		const dialogRef = this.dialog.open(AddSegmentDialogComponent, {
			width: "450px",
			data: { title: "Add Segment" },
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === "updated") {
				this.getSegments();
			}
		});
	}

	showSegmentUserListDialog(rec) {
		const dialogRef = this.dialog.open(AdduserlistComponent, {
			width: "650px",
			data: rec,
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === "updated") {
				this.getSegments();
			}
		});
	}

	showEditSegmentDialog(rec) {
		let editSegmentDialogRef = this.dialog.open(EditSegmentDialogComponent, {
			width: "450px",
			data: { rec: rec },
		});

		editSegmentDialogRef.afterClosed().subscribe((result) => {
			if (result === "updated") {
				this.getSegments();
			}
		});
	}

	applyFilter() {
		console.log(this.searchTxt);
		if (this.searchTxt !== "") {
			this.searchByText = true;
			this.notificationService
				.getFilteredSegmentList(this.searchTxt)
				.subscribe((response: any) => {
					this.segments = response.data;
					this.segments.forEach((item) => {
						item["actions"] = [
							{
								name: "edit",
								tip: "Edit Segment",
							},
						];
						if (item.isAssociated === true) {
							if (item.isActive === true) {
								item["actions"].push({
									name: "not_interested",
									tip: "De-activate Segment",
								});
							} else {
								item["actions"].push({
									name: "check_circle",
									tip: "Activate Segment",
								});
							}
						} else {
							item["actions"].push({
								name: "delete",
								tip: "Delete Segment",
							});
						}

						item["actions"].push({
							name: "groups",
							tip: "Segment user list",
						});
					});
				});
		} else {
			this.searchByText = false;
			this.getSegments();
		}
	}
	clear() {
		this.searchTxt = "";
		this.applyFilter();
	}
}
